import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { BrandLogo, Reference } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { CMSImage } from '@swf/cms';
import FoxBetMenuIcon from '@swf/core/assets/fox-bet.svg';
import FullTiltMenuIcon from '@swf/core/assets/fulltilt-mobile.svg';
import PokerMenuIcon from '@swf/core/assets/poker-menu.svg';
import { select } from '@swf/core/store';

import styles from './BrandIconMobile.scss';

interface Props {
  brandIcon: Reference[];
}

const menuIcons: Partial<Record<BrandTypes, typeof PokerMenuIcon>> = {
  [BrandTypes.POKER_STARS]: PokerMenuIcon,
  [BrandTypes.STARS_CASINO]: PokerMenuIcon,
  [BrandTypes.BET_STARS]: PokerMenuIcon,
  [BrandTypes.FULL_TILT]: FullTiltMenuIcon,
  [BrandTypes.FOX_BET]: FoxBetMenuIcon
};

const BrandIconMobile: React.FC<Props> = ({ brandIcon }) => {
  const brand = useSelector(select.cms.getBrandId);
  const site = useSelector(select.cms.getSiteId);
  const hamburgerBrandIcon = brandIcon.length ? (brandIcon[0] as BrandLogo).hamburger : null;

  return (
    <>
      {hamburgerBrandIcon && <CMSImage {...hamburgerBrandIcon} />}
      {menuIcons[brand] &&
        !hamburgerBrandIcon &&
        React.createElement(menuIcons[brand], {
          className: classNames(styles.icon, {
            [styles.pokerIcon]: [BrandTypes.POKER_STARS, BrandTypes.STARS_CASINO].includes(brand),
            [styles.deshIcon]: site === Sites.DE_SH
          })
        })}
    </>
  );
};

export default BrandIconMobile;
